module.exports = __webpack_public_path__ + "img/立.f49e3dc3.jpg";